<template lang="html">
  <!-- v-if="controlFile" -->
  <div class="admin-files-wrapper">
    <div class="title">
      <span>{{ $t('competitions.main.documents') }}</span>
      <!-- <locale-picker /> -->
      <dropdown
        :defaultText="$t('competitions.main.competition')"
        :selected="competition"
        :list="competitionList"
        @changeOption="competition = $event"
        :removable="true"
        @remove="competition = null"
      />
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <td>{{$t('competitions.modal.nameDocuments')}}</td>
            <td style="width: 150px;"></td>
            <td style="width: 150px;"></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="document in documents" :key="document.id">
            <td>
              {{ document.cmd_name }}
            </td>
            <td>
              <div @click="openEditModal(document)" class="btn">
                {{ $t('competitions.main.edit') }}
              </div>
            </td>
            <td>
              <div @click="openConfirmationModal(document)" class="btn">
                {{ $t('competitions.main.delete') }}
              </div>
            </td>
          </tr>
          <tr v-if="competition && (!documents || documents.length === 0)">
            <td>
              {{ $t('competitions.modal.noSelectDocument') }}
            </td>
          </tr>
          <tr v-if="!competition">
            <td>
              Odaberite konkurs.
              {{ $t('competitions.modal.selectCompetitions') }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="action-wrapper">
      <div @click="openNewModal()" class="btn">
        {{ $t('competitions.main.addDocument') }}
      </div>
    </div>
  </div>
</template>

<script>
// import LocalePicker from '@/components/header/LocalePicker.vue'
import Dropdown from '@/components/dropdown.vue'
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'adminCompetitionRules',
  components: {
    // LocalePicker
    Dropdown
  },
  data () {
    return {
      documents: [],
      competitionList: [],
      competition: null
    }
  },
  activated () {
    this.fetchCompetitionRules()
    this.getCompetitions()
  },
  methods: {
    fetchCompetitionRules () {
      if (!this.competition) {
        this.documents = []
        return
      }
      let params = {
        cmp_id: this.competition.value
      }
      api.fetchCompetitionRules(params).then(res => {
        this.documents = res.data.data
      })
    },
    async getCompetitions () {
      try {
        let res = await api.getAllCompetitions()
        let competitionList = []
        for (var i = 0; i < res.data.data.length; i++) {
          competitionList.push({
            value: res.data.data[i].cmp_id,
            label: res.data.data[i].cmp_name
          })
        }
        this.competitionList = competitionList
      } catch (e) {
        console.log(e)
      }
    },
    openConfirmationModal (document) {
      let modalData = {
        title: this.$t('competitions.main.deleteThis') + document.cmd_name,
        ok: () => {
          this.deleteDocument(document)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    deleteDocument (document) {
      let params = {
        id: document.cmd_id
      }
      api
        .deleteCompetitionDocument(params)
        .then(res => {
          this.fetchCompetitionRules()
          this.$toast.success(this.$t('competitions.main.success'), {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error(this.$t('competitions.tr.error'), {
            duration: 8000
          })
        })
    },
    openEditModal (document) {
      let newDoc = {
        doc_id: document.cmd_id,
        doc_name: document.cmd_name,
        doc_type: document.cmd_type
      }
      let modalData = {
        title: this.$t('competitions.main.edit')+' ' + document.cmd_name,
        document: newDoc,
        ok: res => {
          this.editDocument(res)
        }
      }
      let params = {
        modalData: modalData,
        component: 'editDocument'
      }
      eventBus.$emit('openModal', params)
    },
    editDocument (document) {
      let params = {
        cmd_name: document.doc_name,
        id: document.doc_id
      }
      api
        .editCompetitionDocument(params)
        .then(res => {
          this.fetchCompetitionRules()
          this.$toast.success(this.$t('competitions.main.success'), {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error(this.$t('competitions.tr.error'), {
            duration: 8000
          })
        })
    },
    openNewModal () {
      if (!this.competition) {
        this.$toast.error(
          this.$t('competitions.main.selectContestForDocument'),
          {
            duration: 8000
          }
        )
        return
      }
      let modalData = {
        title: this.$t('competitions.main.addDocument'),
        ok: document => {
          this.addDocument(document)
        }
      }
      let params = {
        modalData: modalData,
        component: 'addDocument'
      }
      eventBus.$emit('openModal', params)
    },
    addDocument (document) {
      let params = new FormData()
      params.append('cmp_id', this.competition.value)
      params.append('cmd_name', document.doc_name)
      params.append('cmd_document', document.doc_document)
      api
        .addCompetitionDocument(params)
        .then(res => {
          this.fetchCompetitionRules()
          this.$toast.success(this.$t('competitions.main.success'), {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error(this.$t('competitions.tr.error'), {
            duration: 8000
          })
        })
    }
  },
  watch: {
    '$route.params.lang': {
      handler: function () {
        this.fetchCompetitionRules()
      }
    },
    competition: {
      handler: function () {
        this.fetchCompetitionRules()
      }
    }
    // '$i18n.locale': {
    //   handler (newLocale, oldLocale) {
    //     if (newLocale !== oldLocale) {
    //       if (this.$route.params.hasOwnProperty('lang')) {
    //         this.controlFile = false
    //         setTimeout(() => {
    //           this.controlFile = true
    //         }, 10)
    //       }
    //     }
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.admin-files-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';
  @import '@/assets/scss/tableStyles.scss';
  height: 100%;
  position: relative;

  .table-wrapper {
    height: calc(100% - 160px);
    overflow: auto;
    margin-bottom: 20px;
  }

  .title {
    margin-bottom: 25px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    span {
      margin-right: 20px;
    }
  }
  table {
    margin-bottom: 20px;
  }
  .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
